export const faqData = [
  {
    pergunta: "Quais especialidades são atendidas?",
    resposta: `
      A Clínica Mediaçõa oferece atendimento em mais de 12 especialidades, como:
      <ul class="list-disc list-inside mt-2">
        <li>Psicologia TCC</li>
        <li>Psicologia Sistêmica</li>
        <li>Psicologia Humanista</li>
        <li>Fonoaudiologia</li>
        <li>Nutrição</li>
        <li>Fisioterapia</li>
        <li>Psicopedagogia</li>
        <li>Neurologia Pediátrica</li>
        <li>Neurologia Adultos</li>
        <li>Psiquiatria</li>
        <li>Terapeuta de Casais</li>
        <li>Pedagogo / Acompanhante Terapêutico</li>
      </ul>
      <p class="italic mt-3">
        Confira a lista completa e agende a sua consulta <a href="http://localhost:3000/especialidades" class="underline text-blue-600">aqui</a>
      </p>
    `
  },
  {
    pergunta: "Quais são os valores de consultas e exames?",
    resposta: `Os valores variam conforme a especialidade e exame. Consulte nossa central.`
  },
  {
    pergunta: "Qual o horário de funcionamento das unidades?",
    resposta: `Atendemos de segunda a sexta das 08:00h às 12:00h e das 13:30h às 18:00h.`
  },
  {
    pergunta: "Qual o endereço da Clínica Mediação?",
    resposta: `Clique no ícone de localização ao lado do endereço logo abaixo.`
  }
];
